import { render, staticRenderFns } from "./JianKang_MyTakePartIn.vue?vue&type=template&id=0a8fac13&scoped=true"
import script from "./JianKang_MyTakePartIn.vue?vue&type=script&lang=js"
export * from "./JianKang_MyTakePartIn.vue?vue&type=script&lang=js"
import style0 from "./JianKang_MyTakePartIn.vue?vue&type=style&index=0&id=0a8fac13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8fac13",
  null
  
)

export default component.exports